import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import Calculator from "@/components/preventivo/Calculator";
import QuoteHistory from "@/components/preventivo/QuoteHistory";
import QuoteSettings from "@/components/preventivo/QuoteSettings";
import AiPricing from "@/components/preventivo/AiPricing";

const TABS = [["calc", "Preventivo"], ["history", "Storico"], ["ai", "Suggerimenti AI"], ["settings", "Impostazioni calcolatore"]];

export default function Preventivo() {
  const [tab, setTab] = useState("calc");
  const [s, setS] = useState(null);
  const load = () => { api.get("/quote-settings").then((r) => setS(r.data)); };
  useEffect(() => { load(); }, []);
  const L = s?.listini.find((l) => l.id === s.active_id);
  return (
    <div data-testid="preventivo-page">
      <PageHeader title="Preventivatore" subtitle={L ? `Listino attivo: ${L.name}` : ""} />
      <div className="flex flex-wrap gap-1 mb-4" data-testid="preventivo-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`preventivo-tab-${k}`} onClick={() => setTab(k)}
            className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${tab === k ? "bg-sky-700 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
      </div>
      {s && tab === "calc" && <div className="max-w-2xl"><Calculator key={L.id} L={L} links={s.links} /></div>}
      {tab === "history" && <QuoteHistory />}
      {tab === "ai" && <AiPricing />}
      {s && tab === "settings" && <QuoteSettings settings={s} onSaved={load} />}
    </div>
  );
}
